<template>
    <div v-if="isMobile">
        <!-- loading -->
        <b-row v-if="$store.state.loading" style="position: fixed; top: 229px; left: 8px; right: 8px; z-index: 1000; background-color: #f2f2f2; opacity: 1; height: auto;"> 
            <b-col sm="12" class="text-center">
                <!-- <h5>{{$t('loading')}}</h5> -->
                <div class="sk-wave" style="transform: scale(0.8);">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </b-col>
        </b-row>
    </div>
    <div v-else>
        <!-- loading -->
        <b-row v-if="$store.state.loading"> 
            <b-col sm="12" class="text-center">
                <h5>{{$t('loading')}}</h5>
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>


export default {
    name: 'Loader',

    computed: {
        isMobile() {
            return window.innerWidth <= 767;
        }
    },
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />